import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE, STRONG_PASSWORD_REGEX } = validations

const strongPassword = {
  name: 'strongPassword',
  schemaType: STRING_SCHEMA_TYPE,
  method(
    message = 'Sua nova senha deve possuir letras minúsculas, maiúsculas, números e pelo menos um caractere especial',
  ) {
    return this.matches(STRONG_PASSWORD_REGEX, {
      message,
      excludeEmptyString: true,
    })
  },
}

export default strongPassword
